import { useEffect, useState } from "react";
import { FiShield, FiCheckCircle } from "react-icons/fi";
import { useFlowManager } from "../../../hooks/useFlowManager";

const PaymentPage = () => {
  const { goToPaymentSuccess } = useFlowManager();
  const [count, setCount] = useState(5);

  useEffect(() => {
    let timer = setInterval(() => {
      setCount((c) => Math.max(c - 1, 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (count === 0) {
      goToPaymentSuccess();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  useState(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-green-100 px-4">
      <div className="bg-white p-10 rounded-3xl shadow-xl max-w-md w-full text-center border border-green-100 relative overflow-hidden">
        {/* Soft Glow */}
        <div className="absolute inset-0 bg-gradient-to-r from-green-200/20 to-transparent blur-2xl opacity-50" />

        {/* Secure Badge */}
        <div className="flex items-center justify-center gap-2 mb-5 z-10 relative">
          <FiShield className="text-green-600" size={26} />
          <p className="text-sm font-medium text-gray-700">
            Secure Payment Gateway
          </p>
        </div>

        {/* Loader Ring (Green Spinner) */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full border-[6px] border-green-400/30 border-t-green-600 animate-spin" />

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-2 z-10 relative">
          Processing Your Payment
        </h2>

        <p className="text-gray-600 mb-6 z-10 relative">
          Please wait, we are securely confirming the transaction…
        </p>

        {/* Countdown */}
        <div className="flex items-center justify-center gap-2 text-gray-700 font-medium text-lg">
          <FiCheckCircle className="text-green-600" size={20} />
          <span>
            Completing in{" "}
            <span className="text-green-600 font-semibold">{count}</span>{" "}
            seconds…
          </span>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
